import { API } from 'aws-amplify';

export const createProdCampTokenService = (data) => {
    
    return API.post(
        'main',
        `/prodcamp/create-token`, 
        {
            body : data,
            headers: { "Content-Type":"application/json" }
        }
    ).then(resp => {

        return resp.data

    }).catch((error)=>{

        console.log('error', error)
            
        return error

    });
}